import * as LinkIssuesSelector from './link-issues.selectors';
import {SharedIssueBaseSelectors} from "@shared/components/issues/store/shared-issue-base.selectors-type";

const LinkIssuesSelectorsMerge = { ...LinkIssuesSelector, ...SharedIssueBaseSelectors };
export {LinkIssuesSelectorsMerge as LinkIssuesSelectors};
